export default {
  title: 'Delivery providers',
};
